(function () {
  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var product = window.__currentProduct;

      // ── 1. /cart/add.js — inject "Voor product" property on add-ons ──────────
      if (
        product && product.title && product.variantIds &&
        url.indexOf('/cart/add') !== -1 &&
        init && typeof init.body === 'string'
      ) {
        var variantSet = {};
        for (var i = 0; i < product.variantIds.length; i++) {
          variantSet[String(product.variantIds[i])] = true;
        }

        var parsed;
        try { parsed = JSON.parse(init.body); } catch (e) { parsed = null; }

        if (parsed) {
          var modified = false;

          if (parsed.items && Array.isArray(parsed.items)) {
            parsed.items = parsed.items.map(function (item) {
              if (!variantSet[String(item.id)]) {
                modified = true;
                var props = item.properties || {};
                props['Voor product'] = product.title;
                return Object.assign({}, item, { properties: props });
              }
              return item;
            });
          } else if (parsed.id && !variantSet[String(parsed.id)]) {
            parsed.properties = Object.assign({}, parsed.properties || {}, {
              'Voor product': product.title,
            });
            modified = true;
          }

          if (modified) {
            init = Object.assign({}, init, { body: JSON.stringify(parsed) });
          }
        }
      }

      // ── 2. /cart/change.js — cascade-remove add-ons when main product removed ─
      if (url.indexOf('/cart/change') !== -1 && init && typeof init.body === 'string') {
        var changeParsed;
        try { changeParsed = JSON.parse(init.body); } catch (e) { changeParsed = null; }

        if (changeParsed && changeParsed.quantity === 0 && changeParsed.line) {
          var self = this;

          return originalFetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var removedItem = cart.items[changeParsed.line - 1];

              // Item not found — proceed normally
              if (!removedItem) return originalFetch.call(self, input, init);

              // It's an add-on itself being removed — proceed normally, don't cascade
              if (removedItem.properties && removedItem.properties['Voor product']) {
                return originalFetch.call(self, input, init);
              }

              // It's a main product — find all linked add-ons by their cart item key
              var productTitle = removedItem.product_title;
              var mainItemKey = removedItem.key;

              var addonKeys = cart.items
                .filter(function (item) {
                  return item.properties && item.properties['Voor product'] === productTitle;
                })
                .map(function (item) { return item.key; });

              // No linked add-ons — proceed normally
              if (addonKeys.length === 0) return originalFetch.call(self, input, init);

              // Remove add-ons first (silently, without section re-render)
              var updates = {};
              addonKeys.forEach(function (key) { updates[key] = 0; });

              return originalFetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates }),
              })
                .then(function () {
                  // After add-ons are gone, find the main product's new line index
                  return originalFetch('/cart.js').then(function (r) { return r.json(); });
                })
                .then(function (updatedCart) {
                  var newIdx = -1;
                  for (var i = 0; i < updatedCart.items.length; i++) {
                    if (updatedCart.items[i].key === mainItemKey) { newIdx = i; break; }
                  }

                  // Main item already gone somehow — proceed with original call anyway
                  if (newIdx === -1) return originalFetch.call(self, input, init);

                  // Remove the main product at its (possibly shifted) line index
                  var updatedBody = JSON.stringify(
                    Object.assign({}, changeParsed, { line: newIdx + 1 })
                  );
                  return originalFetch.call(self, input, Object.assign({}, init, { body: updatedBody }));
                });
            });
        }
      }

    } catch (e) {
      // Never break cart functionality
    }

    return originalFetch.call(this, input, init);
  };
})();
